import clsx from 'clsx';
import React, {} from 'react';
import { Col, Row } from 'components/layout';
import { ContentBlockSimpleTitle } from './components';
import './ContentBlockSimple.scss';
const ContentBlockSimple = ({ children, className, bodyClassName, title, titleLight }) => (React.createElement(Row, { className: clsx('content-block-simple', className) },
    React.createElement(ContentBlockSimpleTitle, { title: title, titleLight: titleLight }),
    React.createElement(Col, { className: bodyClassName }, children)));
export default ContentBlockSimple;
